import { useState, useEffect, useRef} from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";

import CountryDataService from "../../services/countries.service";

import CountryData from '../../types/country.type';
import logo from '../../assets/images/logo.svg';
import errorFace from '../../assets/images/errorFace.svg';
import errorConexion from '../../assets/images/errorConexion.svg';
import registrate from '../../assets/images/registrate.png';
import flag from '../../assets/images/flag.svg';
import document from '../../assets/images/document.svg';
import calendar from '../../assets/images/calendar.svg';
import phone from '../../assets/images/phone.svg';
import Select from 'react-select'
import Input from '../../components/form/Input';
import "react-datepicker/dist/react-datepicker.css";
import addPersonData from "../../types/addPerson.type";
import OnboardingDataService from "../../services/onboarding.service";
import Swal from 'sweetalert2'
import es from 'date-fns/locale/es';
import DocumentsService from "../../services/documents.service";

import ReCAPTCHA from "react-google-recaptcha";

import ReactDatePicker, { registerLocale } from "react-datepicker";
import NextButton from '../../components/ui/NextButton';
import { sendEvent } from '../../utils/firebase';

function FirstStep() {

  useEffect(() => {
    DocumentsService.generateToken()
  }, []);

  const recaptchaRef = useRef<ReCAPTCHA>(null)

  const navigate = useNavigate();
  registerLocale('es', es)
  const [data, setData] = useState({
    countries: [],
    documentType: '',
    ci: '',
    name: '',
    lastname: '',
    phone: '',
    country: '',
    prefix: '',
    sex: '',
    exist: true,
  });
useEffect(() => {
  localStorage.clear();
}, []);


  // const playerRef = useRef<Player>(null);
  const [regexp, setReg] = useState("");
  const [validateCi, setCi] = useState(false);
  const [validateName, setName] = useState(false);
  const [validateLastname, setLastame] = useState(false);
  const [validateCountry, setCountryState] = useState(false);
  const [validateBirthday, setBirthday] = useState(false);
  const [validatePhone, setPhone] = useState(false);
  const [phoneStart, setPhoneStart] = useState(false);
  const [validateCaptcha, setCaptchaStatus] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hideTransition, setIsHiden] = useState(false);
  const [birthdate, setDate] = useState(null);

  function format(inputDate: { getDate: () => any; getMonth: () => number; getFullYear: () => any; }) {
    let date, month, year;
  
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
  
      date = date
          .toString()
          .padStart(2, '0');
  
      month = month
          .toString()
          .padStart(2, '0');
  
    return `${year}-${month}-${date}`;
  }

  useEffect(() => {
    retrieveCountries();
  }, []);
  useEffect(() => {
    origin();
  }, []);

  const retrieveCountries = () => {
    CountryDataService.getAll()
      .then((response: any) => {
        setData({
          ...data,
          countries: response.data,
        });
      })
      .catch(() => {
        Swal.fire({
          title: 'Sin conexión',
          text:"Vuelva a intentarlo en unos minutos.",
          imageUrl: errorConexion,
          imageWidth: 200,
          imageHeight: 200,
          imageAlt: 'Custom image',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false
        })
      });
   }

   const key = (e:any) => {
    if(e.keyCode === 9){
      if(!data.ci) {
        setCi(true);
        e.preventDefault()
        return;
      }
      if(!data.country) {
        setCountryState(true);
        e.preventDefault()
        return;
      }
    }
  };

   const getPerson = (ci: string) => {
    if (ci.length < 4) {
      setCi(true);
      return;
    }
    if (regexp === "") {
      setCountryState(true);
      return;
    }
    let reg = RegExp(regexp);
    let test = reg.test(ci);
    if (!test) {
      setCi(true);
      return;
    }

    CountryDataService.get(ci, data.documentType)
      .then((response: any) => {
        if (response.data.success) {
          setData({
            ...data,
            exist: true,
          });
       } else {
        setData({
          ...data,
          exist: false,
        });
       }
      })
      .catch((e: Error) => {
        console.log(e);
      });
   }

  const options =  data.countries.map((country: CountryData) => ({ value: country.id, label: country.description,name: country.nationalityName, prefix: country.prefix }));
  
  const onChange = (e: any) => {
    if (e.target.name === 'ci') {
      setCi(false);
    }
    if (e.target.name === 'name') {
      setName(false);
    }
    if (e.target.name === 'lastname') {
      setLastame(false);
    }
    if (e.target.name === 'phone') {
      setPhone(false);
      if(e.target.value.charAt(0) !== "0") {
        setPhoneStart(true);
        return;
      }
      if(e.target.value.charAt(1) !== "9" && e.target.value.length === 2) {
        setPhoneStart(true);
        return;
      }
      setPhoneStart(false);
    } 
    
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const hideOnboarding = () => {
    setIsActive(current => !current);
    setTimeout(() => {
      setIsHiden(current => !current);
    }, 1000)
  };

  const SetCountry = (e: any) => {
    setCountryState(false);
    CountryDataService.getDocumentType(e.value)
    .then((response: any) => {
      setData({
        ...data,
        documentType: response.data[0].id,
        country: e.label,
        prefix: e.prefix,
      });
      setReg(response.data[0].pattern);
    })
    .catch((e: Error) => {
      console.log(e);
    });
  }

  const selectStyle = {
    option: () => ({
      borderBottom: '0px',
      padding: 20,
      color: '#9ca3af',
    }),
    control: () => ({
      display: 'flex',
      color: '#9ca3af',
    }),
  }

  const validateYears = (inputDate: string | number | Date) => { 
    let date = new Date(inputDate);
    let today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    let m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      age--;
    }
    if (age < 18) {
      setBirthday(true);
    } else {
      setBirthday(false);
    }
  }
  const setMaxDateFunction = () => {
    let date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return date;
  }
 
  const makeid = (length: number) => {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const register = () => {

    if(!data.ci) {
     setCi(true);
    }
    if(!data.country) {
      setCountryState(true);
    }
    if(!birthdate) {
      setBirthday(true);
    }else{
      validateYears(birthdate);
    }
    if(!data.phone) {
      setPhone(true);
    }
    if(captcha === "") {
      setCaptchaStatus(true);
    }
    if(!data.ci||!birthdate||!data.phone||captcha === "") {
      return;
    }
    const cleanPhone = data.phone.replace(/\s+/g, "").trim();
    setIsDisabled(true);
    setLoading(true);
    const person: addPersonData = {
      personData: {
        documentNumber: data.ci,
        documentType: data.documentType,
        firstName:data.name,
        middleName: "", 
        lastName:data.lastname,
        sex: data.sex? data.sex : "MALE",
        maritalStatus: "NOT_SPECIFIED",
        cityCode: "",
        fullName: data.name + " " + data.lastname,
        birthDate: birthdate? format(birthdate) : ""
      },
      token:captcha,
      phoneNumber: cleanPhone,
      prefix: data.prefix,
      securityProfileId: 'P1-Web',
      userContextData: {
        deviceInfo: {
          securityProfileId: 'P1-Web',
          deviceFingerPrint: makeid(45),
          clientDeviceId: '',
          simIccid: '',
          deviceBrand: 'Chrome',
          deviceModel: 'emulator_arm64',
          deviceOS: 'Windows',
          imei: '',
          fcmDeviceId: '',
          patovikSignature: '',
          appVersion: '2.133.0',
          timestamp: '1654288297905',
          debugEnabled: true
        }
      }
    };
    sendEvent("INICIO_EL_REGISTRO");
    OnboardingDataService.initChallenge(person)
      .then((response: any) => {
        DocumentsService.generateToken()
        setLoading(false);
        localStorage.setItem('page', response.data.challengeName);
        switch(response.data.challengeName) {
          case "NEED_ADDITIONAL_DATA":
            DocumentsService.generateToken()
            return navigate('/datos-adicionales',
            {
                state: {
                    sessionId: response.data.sessionId,
                    name: response.data.enrollmentCustomer.firstName,
                }
            });
            case "NEED_PASSWORD":
            return navigate('/clave',
            {
                state: {
                    sessionId: response.data.sessionId,
                    name: response.data.enrollmentCustomer.firstName,
                }
            });
          case "NEED_TO_UPLOAD_DOCUMENTS":
            return navigate('/documentos',
            {
                state: {
                    sessionId: response.data.sessionId,
                    customerId: response.data.enrollmentCustomer.customerId,
                }
            });
          case "NEED_TO_REGISTER_DEVICE":
            return navigate('/verificar-dispositivo',
            {
                state: {
                    sessionId: response.data.sessionId,
                    deviceId: response.data.deviceEnrollmentParams.deviceId,
                    deviceFingerPrint:person.userContextData.deviceInfo.deviceFingerPrint,
                }
            });
          default:
            return  "NEED_TO_REGISTER_DEVICE";
        }
      })
      .catch((e: any) => {
        setCaptchaStatus(false)
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        setCaptcha("");
        setLoading(false);
        setIsDisabled(false);
        Swal.fire({
          title: '¡Ooops!',
          text:e.response.data.message,
          imageUrl: errorFace,
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: 'Custom image',
        })
      });
  }
  const [searchParams] = useSearchParams();
  const origin = () => {
    const origin =  searchParams.get("origin")
    if (origin === "SMS"){
      sendEvent("INGRESO_POR_SMS");
    } else {
      sendEvent("INGRESO_A_LA_WEB");
    }
  };

  
  return (
    <div className="dark:bg-bgDark h-full">
      <header className="w-full pt-10 pb-2">
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className="container mx-auto grid md:grid-cols-2 sm:grid-cols-1 dark:bg-bgDark">
        <div className={hideTransition ? 'onboardingIntro hide dark:bg-bgDark' : 'onboardingIntro dark:bg-bgDark'}>
          <div className={isActive ? 'transition show' : 'transition'}>
            <div className="layer one"></div>
            <div className="layer two"></div>
            <div className="layer three dark:bg-bgDark"></div>
          </div>
          <div className="flex flex-col onboardingContainer justify-between bg-white dark:bg-bgDark">
            <header className="mt-10">
              <img src={logo} className="h-12 mx-auto hideOnDesktop mb-10" alt="Wally" />
              <img src={registrate} className="sliderImage" alt="Wally" />
            </header>
            <main className="mb-auto mt-10 onboardingDescription">
              <h1 className="text-2xl text-wallyGray font-regular dark:text-white">Registrate a Wally</h1>
              <p className=" font-sm mt-5 text-gray-400">Hacé tu registro digital para enviar y recibir tus giros Wally en el punto de venta.</p>
            </main>
            <footer className="pb-40 hideOnDesktop">
              <button onClick={hideOnboarding}  className="text-white text-xl w-full  bg-wallyBlue  rounded-full p-4 mt-5">
                  REGISTRARME
              </button>
            </footer>
          </div>
        </div>
        <div className={hideTransition ? 'w-full mx-auto max-w-md form show p-3' : 'w-full max-w-md mx-auto form p-3'}>
          <h1 className="text-2xl mb-4 text-wallyGray font-semibold title dark:text-white">Ingresá tus datos</h1>
          <div className= {validateCountry ? 'shakeError w-full flex bg-gray-50 border border-red-400 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400' :'w-full flex bg-gray-50 border border-gray-300 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'}>
            <div className="w-1/6">
              <img src={flag} className="mx-auto selectIcon" alt="Wally" />
            </div>
            <div className="w-5/6 ">
              <Select
                className='offSelect text-xl dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'
                styles={selectStyle}
                placeholder="País emisor del documento"
                options={options}
                onChange={SetCountry}
              />
            </div>
          </div>
          {validateCountry? <p className="text-red-500 text-center text-sm mt-1">El campo es requerido</p> : null}
        
          <div className={validateCountry? "mt-1" : "mt-6"}>
            <Input
              onChange={onChange}
              error={validateCi}
              message={validateCi ? 'El campo es requerido' : ''}
              name="ci"
              placeholder="Número de documento"
              onKeyDown={(e) => { key(e)}}
              value={data.ci}
              icon={document}
              onBlur={() => {
                getPerson(data.ci);
              }}

            />
          </div>
          {!data.exist ?
          <div>
               <div className={validateCi? "mt-1" : "mt-6"}>
                <Input
                  onChange={onChange}
                  error={validateName}
                  message={validateName ? 'El campo es requerido' : ''}
                  name="name"
                  placeholder="Nombre"
                  value={data.name}
                  icon={document}
                  onBlur={() => {}}
                  onKeyDown={() => {}}
                />
              </div>
              <div className={validateName? "mt-1" : "mt-6"}>
                <Input
                  onChange={onChange}
                  error={validateLastname}
                  message={validateLastname ? 'El campo es requerido' : ''}
                  name="lastname"
                  placeholder="Apellido"
                  value={data.lastname}
                  icon={document}
                  onBlur={() => {}}
                  onKeyDown={() => { }}
                />
              </div>
          </div>
          : null}
         <div className={validateCi? "mt-1" : "mt-6"}>
            <div className= {validateBirthday ? 'w-full shakeError flex bg-gray-50 border border-red-400 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400' :'w-full flex bg-gray-50 border border-gray-300 rounded-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'}>
              <div className="w-1/6">
                <img src={calendar} className="mx-auto" alt="Wally" />
              </div>
              <div className="w-5/6 ">
                <ReactDatePicker
                  maxDate={setMaxDateFunction()}
                  startDate={setMaxDateFunction()}
                  locale="es"
                  selected={birthdate}
                  onChange={(date: any) => setDate(date)}
                  dateFormat="yyyy/MM/dd"
                  className="text-xl inputDate bg-gray-50 placeholder-gray-500 text-gray-900 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  disabledKeyboardNavigation
                  onChangeRaw={(e) => e.preventDefault()}
                  dropdownMode="select"
                  placeholderText="Fecha de nacimiento"
                  onKeyDown={() => {return false}}
                />
              </div>
            </div>
            {validateBirthday ? <p className="text-red-500 text-center text-sm mt-1">El campo es requerido</p> : null}
          </div>
          <div className={validateBirthday? "mt-1" : "mt-6"}>
            <Input
              onChange={onChange}
              name="phone"
              error={validatePhone}
              message={validatePhone ? 'El campo es requerido' : ''}
              placeholder="Número de teléfono"
              value={data.phone}
              icon={phone}
              onBlur={() => {}}
              onKeyDown={() => {}}
            />
            {phoneStart? <p className="text-red-500 text-center text-sm mt-1">El número de teléfono debe comenzar con 09.</p> : null}
          </div>
          <div className={validatePhone? "captcha" : "mt-4 captcha"}>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LcpU1kjAAAAAJWkAQ07sKhlj9BUyuJaxyWRB6Ql"
                onChange={(e) => (setCaptcha(e || ""))}
             />
              {validateCaptcha? <p className="text-red-500 text-center text-sm mt-1">Debe marcar el captcha</p> : null}
          </div>
          <div className="relative mt-7">
            <p className="text-gray-400">Al continuar estas aceptando los <a className="text-wallyGray font-semibold dark:text-white" href="https://www.wally.com.py/byc.html" target={"_BLACK"}>Términos y Condiciones.</a></p>
            <NextButton
              name="SIGUIENTE"
              onClick={register}
              isDisabled={isDisabled}
              loading ={isLoading}
            />
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default FirstStep;